
import { useEffect, useState, useRef } from "react";
import "./Dropdown.css";

const Dropdown_fontFamily = (props) => {
  const {
    label,
    value,
    onChange,
    onOptionPreview,
    onOptionPreviewEnd,
    options,
    inputBox,
    selectedID,
  } = props;
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const [scrollToIndex, setScrollToIndex] = useState(selectedID);
  const dropdownOptionsRef = useRef(null);

  let useClickOutside = (handler) => {
    let domNode = useRef();

    useEffect(() => {
      let isHandler = (event) => {
        if (!domNode.current.contains(event.target)) {
          handler();
        }
      };

      document.addEventListener("mousedown", isHandler);

      return () => {
        document.removeEventListener("mousedown", isHandler);
      };
    });

    return domNode;
  };

  let domNode = useClickOutside(() => {
    onOptionPreviewEnd?.();
    setIsOptionsVisible(false);
  });

  useEffect(() => {
    if (isOptionsVisible && dropdownOptionsRef.current) {
      const selectedOptionElement = dropdownOptionsRef.current.children[scrollToIndex];
      if (selectedOptionElement) {
        selectedOptionElement.scrollIntoView?.({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [isOptionsVisible, scrollToIndex]);

  const handleSelected = (value, index) => {
    onChange(value);
    onOptionPreviewEnd?.();
    setIsOptionsVisible(false);
    setScrollToIndex(index);
  };

  const handleDisplayClick = () => {
    if (isOptionsVisible) onOptionPreviewEnd?.();
    setIsOptionsVisible(!isOptionsVisible);
  };

  let displayValue = value;
  const idx = options?.findIndex((opt) => opt.value === value);
  if (idx !== undefined && idx !== -1) displayValue = options[idx].label;

  return (
    <div className="DDContainer">

      {label && <span className="DD-label">{label}</span>}

      <div ref={domNode} className="DDContainer-componentFont">

        <div className="DD-DisplayBox" onClick={handleDisplayClick}>

          <div className="DDdisplayvalue">
            {inputBox ? (
              <input
                type="number"
                className="dropdownInput"
                value={value}
                onChange={(evt) => {
                  if (onChange) {
                    onChange(evt.target.value);
                  }
                }}
              />
            ) : (
              displayValue
            )}
          </div>

          <hr />

          <div className="DDbtnContainer">
            {isOptionsVisible ? (
              <span className="DDup-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-tabler icon-tabler-chevron-up"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 15 12 9 18 15"></polyline>
              </svg>
              </span>
            ) : (
              <span className="DDdown-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-tabler icon-tabler-chevron-down"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              </span>
            )}
          </div>
        </div>
        
        {isOptionsVisible && (
          <div
            ref={dropdownOptionsRef}
            className="DD-options-Container"
            role="listbox"
            onMouseLeave={() => onOptionPreviewEnd?.()}
          >
            {options?.map((option, ind) => (
              <div
                key={ind}
                className="dropdown-option w-full"
                role="option"
                aria-selected={ind === selectedID}
                onMouseEnter={() => onOptionPreview?.(option.value)}
                onFocus={() => onOptionPreview?.(option.value)}
                onClick={() => handleSelected(option.value, ind)}
              >
                <div className={"dd-options-menuitem " + (ind === selectedID ? "  dd-options-selected-menuitem" : '')}>{option.label}</div>
                <hr className="dropdown-hr" />
              </div>
            ))}
          </div>
        )}

      </div>

    </div>
  );
};

export default Dropdown_fontFamily;
